import {
  View,
  Text,
  ScrollView,
  TextInput,
  TouchableOpacity,
  Alert,
} from "react-native";
import React, { useState, useEffect } from "react";
import { useStateContext } from "../lib/context";
import { styles } from "../styles/mainStyle";
import Header from "../components/Header";
import { Button } from "@rneui/base";
import Feather from "@expo/vector-icons/Feather";
import { getFirestore, doc, getDoc, setDoc } from "firebase/firestore";
import { auth, db } from "../firebase";

const AdminDashboard = ({ navigation }) => {
  // Context
  const { lastProd } = useStateContext();

  const [selectedOfertas, setSelectedOfertas] = useState([]);
  const [selectedNovedades, setSelectedNovedades] = useState([]);
  const [searchOfertas, setSearchOfertas] = useState("");
  const [searchNovedades, setSearchNovedades] = useState("");
  const [dolar, setDolar] = useState("");
  const [loading, setLoading] = useState(false);

  // Prepare product options with id and label
  const productOptions = Array.isArray(lastProd)
    ? lastProd
        .filter(
          (prod) =>
            prod &&
            typeof prod.ARTICULO__ID === "string" &&
            typeof prod.DENOMINACION === "string"
        )
        .map((prod) => ({
          id: prod.ARTICULO__ID,
          label: prod.DENOMINACION,
        }))
    : [];

  // Filtered options: search by label or id
  const filterOptions = (search) =>
    search.length >= 3
      ? productOptions.filter(
          (option) =>
            option.label.toLowerCase().includes(search.toLowerCase()) ||
            option.id.toLowerCase().includes(search.toLowerCase())
        )
      : [];

  const filteredOfertas = filterOptions(searchOfertas);
  const filteredNovedades = filterOptions(searchNovedades);

  // Helper for multi-select by id (clears search after selection)
  const handleSelectOfertas = (value) => {
    if (selectedOfertas.includes(value)) {
      setSelectedOfertas(selectedOfertas.filter((item) => item !== value));
    } else {
      setSelectedOfertas([...selectedOfertas, value]);
    }
    setSearchOfertas(""); // Clear search after selection
  };

  const handleSelectNovedades = (value) => {
    if (selectedNovedades.includes(value)) {
      setSelectedNovedades(selectedNovedades.filter((item) => item !== value));
    } else {
      setSelectedNovedades([...selectedNovedades, value]);
    }
    setSearchNovedades(""); // Clear search after selection
  };

  // Helper to get product label by id
  const getLabelById = (id) => {
    const found = productOptions.find((opt) => opt.id === id);
    return found ? found.label : id;
  };

  // Load previous selection from Firestore
  useEffect(() => {
    const fetchConfig = async () => {
      setLoading(true);
      try {
        const docRef = doc(db, "AdminConfig", "main");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          setSelectedOfertas(Array.isArray(data.Ofertas) ? data.Ofertas : []);
          setSelectedNovedades(
            Array.isArray(data.Novedades) ? data.Novedades : []
          );
          setDolar(data.Dolar || "");
        }
      } catch (e) {
        Alert.alert("Error", "No se pudo cargar la configuración.");
      }
      setLoading(false);
    };
    fetchConfig();
    // eslint-disable-next-line
  }, []);

  // Save selection to Firestore
  const saveConfig = async () => {
    setLoading(true);
    try {
      await setDoc(doc(db, "AdminConfig", "main"), {
        Ofertas: selectedOfertas,
        Novedades: selectedNovedades,
        Dolar: dolar,
      });
      Alert.alert("Éxito", "Configuración guardada correctamente.");
    } catch (e) {
      Alert.alert("Error", "No se pudo guardar la configuración.");
    }
    setLoading(false);
  };

  return (
    <ScrollView style={{ backgroundColor: "#F4F6FD", flex: 1 }}>
      <Header navigation={navigation} title="Panel de Admin" />
      <View
        style={{
          margin: 16,
          backgroundColor: "#fff",
          padding: 16,
          borderRadius: 8,
        }}
      >
        <Text style={{ fontWeight: "bold", fontSize: 18, marginBottom: 12 }}>
          Seleccionar Ofertas
        </Text>
        <TextInput
          style={{
            borderWidth: 1,
            borderColor: "#ccc",
            borderRadius: 6,
            padding: 8,
            marginBottom: 8,
            backgroundColor: "#f4f6fd",
          }}
          placeholder="Buscar por nombre o código (mínimo 3 letras)..."
          value={searchOfertas}
          onChangeText={setSearchOfertas}
        />
        {filteredOfertas.map((option) => (
          <Button
            key={`oferta-${option.id}`}
            title={`${option.label} (${option.id})`}
            type={selectedOfertas.includes(option.id) ? "solid" : "outline"}
            buttonStyle={{
              marginBottom: 8,
              backgroundColor: selectedOfertas.includes(option.id)
                ? "#2a2a8e"
                : "#fff",
              borderColor: "#2a2a8e",
            }}
            titleStyle={{
              color: selectedOfertas.includes(option.id) ? "#fff" : "#2a2a8e",
            }}
            onPress={() => handleSelectOfertas(option.id)}
          />
        ))}

        {/* Show current selection for Ofertas */}
        {selectedOfertas.length > 0 && (
          <View style={{ marginTop: 10, marginBottom: 20 }}>
            <Text style={{ fontWeight: "bold", marginBottom: 6 }}>
              Seleccionados:
            </Text>
            {selectedOfertas.map((id) => (
              <View
                key={`selected-oferta-${id}`}
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  marginBottom: 4,
                  backgroundColor: "#eaf0fe",
                  borderRadius: 4,
                  paddingHorizontal: 8,
                  paddingVertical: 4,
                  alignSelf: "flex-start",
                }}
              >
                <Text style={{ marginRight: 8 }}>
                  {getLabelById(id)} ({id})
                </Text>
                <TouchableOpacity onPress={() => handleSelectOfertas(id)}>
                  <Feather name="x" size={18} color="#2a2a8e" />
                </TouchableOpacity>
              </View>
            ))}
          </View>
        )}

        <Text style={{ fontWeight: "bold", fontSize: 18, marginVertical: 16 }}>
          Seleccionar Novedades
        </Text>
        <TextInput
          style={{
            borderWidth: 1,
            borderColor: "#ccc",
            borderRadius: 6,
            padding: 8,
            marginBottom: 8,
            backgroundColor: "#f4f6fd",
          }}
          placeholder="Buscar por nombre o código (mínimo 3 letras)..."
          value={searchNovedades}
          onChangeText={setSearchNovedades}
        />
        {filteredNovedades.map((option) => (
          <Button
            key={`novedad-${option.id}`}
            title={`${option.label} (${option.id})`}
            type={selectedNovedades.includes(option.id) ? "solid" : "outline"}
            buttonStyle={{
              marginBottom: 8,
              backgroundColor: selectedNovedades.includes(option.id)
                ? "#2a2a8e"
                : "#fff",
              borderColor: "#2a2a8e",
            }}
            titleStyle={{
              color: selectedNovedades.includes(option.id) ? "#fff" : "#2a2a8e",
            }}
            onPress={() => handleSelectNovedades(option.id)}
          />
        ))}

        {/* Show current selection for Novedades */}
        {selectedNovedades.length > 0 && (
          <View style={{ marginTop: 10 }}>
            <Text style={{ fontWeight: "bold", marginBottom: 6 }}>
              Seleccionados:
            </Text>
            {selectedNovedades.map((id) => (
              <View
                key={`selected-novedad-${id}`}
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  marginBottom: 4,
                  backgroundColor: "#eaf0fe",
                  borderRadius: 4,
                  paddingHorizontal: 8,
                  paddingVertical: 4,
                  alignSelf: "flex-start",
                }}
              >
                <Text style={{ marginRight: 8 }}>
                  {getLabelById(id)} ({id})
                </Text>
                <TouchableOpacity onPress={() => handleSelectNovedades(id)}>
                  <Feather name="x" size={18} color="#2a2a8e" />
                </TouchableOpacity>
              </View>
            ))}
          </View>
        )}
        <Text style={{ fontWeight: "bold", fontSize: 18, marginBottom: 12 }}>
          Valor del Dólar
        </Text>
        <TextInput
          style={{
            borderWidth: 1,
            borderColor: "#ccc",
            borderRadius: 6,
            padding: 8,
            marginBottom: 8,
            backgroundColor: "#f4f6fd",
          }}
          placeholder="Valor del Dólar"
          value={dolar}
          onChangeText={(text) => setDolar(text)}
        />

        <Button
          title={loading ? "Guardando..." : "Guardar Configuración"}
          buttonStyle={{
            marginTop: 24,
            backgroundColor: "#2a2a8e",
            borderRadius: 8,
          }}
          titleStyle={{
            color: "#fff",
            fontWeight: "bold",
            fontSize: 16,
          }}
          onPress={saveConfig}
          disabled={loading}
        />
      </View>
    </ScrollView>
  );
};

export default AdminDashboard;
